import { LocalizedForm } from "common/localization";

export default class MasterPasswordUpdateForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "currentPassword",
                    label: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.CURRENT_PASSWORD_LABEL",
                    placeholder: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.CURRENT_PASSWORD_PLACEHOLDER",
                    rules: "required|string",
                    type: "password",
                },
                {
                    name: "newPassword",
                    label: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.NEW_PASSWORD_LABEL",
                    type: "password",
                    placeholder: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.NEW_PASSWORD_PLACEHOLDER",
                    rules: [
                        "required",
                        "string",
                        "min:8",
                        "regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/",
                    ],
                },
                {
                    name: "confirmNewPassword",
                    label: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.NEW_PASSWORD_CONFIRMATION_LABEL",
                    placeholder: "ADMINISTRATION.LOADIO.CONFIGURATION.FIELDS.NEW_PASSWORD_CONFIRMATION_PLACEHOLDER",
                    rules: "required|string|same:newPassword",
                    type: "password",
                },
            ],
        };
    }
}
